<!-- 时间轴 -->
<template>
  <div>
    <div
      class="cover"
      :style="{ backgroundImage: 'url('+img_api +pageData.bannerImg + ')' }"
    >
      <div class="front">
        <div class="title">
          <div class="big_title">{{ pageData.firstTitle }}</div>
          <div class="transparent_title">
            {{ pageData.secondTitle }}
          </div>
        </div>
        <div class="des">{{ pageData.des }}</div>
      </div>
    </div>
    <div class="bread_box">
      <div class="crumb">
        <span class="your_position">您所在的位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/build' }">
            {{ pageData.firstTitle }}{{ pageData.secondTitle }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>业绩一览</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="head">
      <div class="return_button" @click="goBack">返回列表页</div>
      <div class="hight_title">
        <div class="cn_title">业绩一览</div>
        <div class="en_title">SUMMARY OF PERFORMANCE</div>
      </div>
    </div>
    <div class="options">
      <div
        class="option"
        v-for="item in optionList"
        :key="item.id"
        :class="tabIndex == item.id ? 'blue_bg' : ''"
        @click="chooseOption(item.id)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="page">
      <div class="per_content">
        <div class="clock">
          <img src="../assets/img/48x48_time@2x.png" alt />
        </div>
        <div v-for="(group, index) in timeLine" :key="index">
          <div v-for="(item,index2) in group.children" :key="index2">
            <div class="first">
              <div
                class="first_left_content"
                :style="{ opacity: index % 2 != 0 ? '0' : '1' }"
              >
                <div class="left_time" v-show="index2 == 0">
                  {{ group.dateYear }}
                </div>
                <div class="content1">
                  <div class="left_content">
                    <div class="icon">
                      <img src="../assets/img/24x24_chanpin@2x.png" />
                    </div>
                    <div class="left_front">
                      <div class="left_title">{{ item.name }}</div>
                      <div class="content_des">{{ item.model }}</div>
                    </div>
                  </div>
                  <div class="right_content">
                    <div class="icon">
                      <img src="../assets/img/24x24_address@2x.png" />
                    </div>
                    <div class="left_front">
                      <div class="left_title">{{ item.address }}</div>
                      <div class="content_des">{{ item.addressDetails }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="line">
                  <div class="cir" v-show="item.id == 0">
                    <img src="../assets/img/12x12_yuan@2x.png" alt />
                  </div>
                </div>
              </div>
              <div
                class="right"
                :style="{ opacity: index % 2 == 0 ? '0' : '1' }"
              >
                <div class="first_right_content">
                  <div class="right_time" v-show="index2 == 0">
                    {{ group.dateYear }}
                  </div>
                  <div class="content2">
                    <div class="left_content">
                      <div class="icon">
                        <img src="../assets/img/24x24_chanpin@2x.png" />
                      </div>
                      <div class="left_front">
                        <div class="left_title">{{ item.name }}</div>
                        <div class="content_des">{{ item.model }}</div>
                      </div>
                    </div>
                    <div class="right_content">
                      <div class="icon">
                        <img src="../assets/img/24x24_address@2x.png" />
                      </div>
                      <div class="left_front">
                        <div class="left_title">{{ item.address }}</div>
                        <div class="content_des">{{ item.addressDetails }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { getPerformanceList } from "@/server/https.js";
export default {
  name: "",
  data() {
    return {
      timeLine: [],
      tabIndex: 0,
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
      optionList: [
        { id: 0, title: "沥青拌合站业绩" },
        { id: 1, title: "施工及设备租赁业绩" },
      ],
    };
  },
  beforeMount() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 6) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
    //获取数据
    this.getList(2);
  },
  methods: {
    //返回上一层
    goBack() {
      this.$router.go(-1); // 返回上一个路由
    },
    getList(index) {
      getPerformanceList({ type: index }).then((res) => {
        //不知道是不是这里
        this.timeLine = res.data.body.findList;
      });
    },
    chooseOption(index) {
      this.tabIndex = index;
      if (index == 0) {
        this.getList(2);
      } 
      else {
        this.getList(1);
      }
    },
  },
};
</script>

<style scoped>
.page {
  display: flex;
  justify-content: center;
}
.cover {
  overflow: hidden;
  height: 355px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.front {
  margin-top: 72px;
  margin-left: 240px;
}

.title {
  display: flex;
}

.big_title {
  font-size: 68px;
  font-weight: bold;
  color: #ffffff;
}

.hight_title {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
}

.transparent_title {
  font-size: 68px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0);
  color: rgba(255, 255, 255, 0);
  -webkit-text-stroke: 1px #ffffff;
  text-stroke: 1px #ffffff;
}

.des {
  font-size: 24px;
  color: #ffffff;
}

.bread_box {
  overflow: hidden;
  height: 60px;
  background-color: #f7f8fa;
}

.crumb {
  display: flex;
  margin-top: 23px;
  margin-left: 140px;
}

.your_position {
  line-height: 1;
  font-size: 14px;
  font-weight: 400;
  color: #13489d;
  margin-right: 5px;
}

.news_page {
  /* position: relative; */
  width: 1200px;
  margin: auto;
}

.content_row {
  display: flex;
  width: 100%;
  height: 15px;
  margin: 10px 0;
}

.content_title {
  line-height: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.colum {
  width: 5px;
  height: 100%;
  margin-right: 20px;
  background-color: #13489d;
}

.head {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 56px;
}

.return_button {
  width: 140px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #5877ba;
  font-size: 18px;
  font-weight: 400;
  color: #13489d;
  line-height: 48px;
  text-align: center;
  position: absolute;
  left: 110px;
}

.return_button {
  cursor: pointer;
}

.options {
  display: flex;
  justify-content: center;
  margin-top: 80px;
}

.option {
  height: 32px;
  line-height: 32px;
  text-align: center;
  padding: 0 15px;
  border-radius: 20px;
  margin: 10px;
  color: #666666;
}

.blue_bg {
  background-color: #13489d;
  color: #ffffff;
}

.per_content {
  position: relative;
  margin-top: 5rem;
}

.first {
  display: flex;
  position: relative;
}

.clock {
  position: absolute;
  left: 33.8rem;
  top: -2.8rem;
  width: 2.8rem;
  height: 2.8rem;
}

.clock img {
  width: 100%;
  height: 100%;
}

.first_left_content {
  position: relative;
  width: 32rem;
    height: 6.5rem;
  background: #f7f8fa;
  display: flex;
  justify-content: start;
  align-items: center;
}

.left_time {
  position: absolute;
  left: 25.5rem;
  top: -2rem;
  width: 6.38rem;
  height: 3.3rem;
  background: #c7922e;
  font-size: 1.5rem;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  line-height: 3.3rem;
}

.right_time {
  position: absolute;
  left: 0rem;
  top: -2rem;
  width: 6.38rem;
  height: 3.3rem;
  background: #c7922e;
  font-size: 1.5rem;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  line-height: 3.3rem;
}

.content1 {
  display: flex;
}

.left_content {
  display: flex;
  margin-left: 2.5rem;
}

.right_content {
  display: flex;
  margin-left: 1.7rem;
}

.left_name {
  justify-content: center;
}

.icon {
  width: 1.5rem;
  height: 1.5rem;
}

.icon img {
  width: 100%;
  height: 100%;
}

.left_front {
  margin-left: 1rem;
  width: 10rem;

}

.left_title {
  font-size: 1rem;
  font-weight: bold;
  color: #333333;
}

.content_des {
  font-size: 0.9rem;
  font-weight: 400;
  color: #999999;
  margin-top: 0.7rem;
}

.line {
  margin-left: 3rem;
  width: 0.38rem;
  height: 7.8rem;
  background: #e9e3d9;
}

.cir {
  position: absolute;
  left: 40.7rem;
  top: 2.5rem;
  width: 1rem;
  height: 1rem;
}

.cir img {
  width: 100%;
  height: 100%;
}

.right {
  float: right;
}

.first_right_content {
  position: relative;
  width: 32rem;
  left: 2rem;
  height: 6.5rem;
  background: #f7f8fa;
  display: flex;
  justify-content: start;
  align-items: center;
}

.content2 {
  display: flex;
  position: absolute;
  left: 4rem;
}
</style>
